import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggerService } from './logger.service';
import { DagAnalyticsModel } from 'src/app/models/dag-analytics/dag-analytics.model';

@Injectable({
  providedIn: 'root'
})
export class DagAnalyticsService {
  private host = environment.apiUrl + 'daganalytics';

  constructor(private http: HttpClient, private logger: LoggerService) { }

  /**
   * Get DAG analytics data for the last week
   * @returns Observable<DagAnalyticsModel[]>
   */
  getDagAnalyticsLastWeek(): Observable<DagAnalyticsModel[]> {
    let url = this.host + '/lastweek';
    return this.http.get<DagAnalyticsModel[]>(url)
      .pipe(
        map((data: DagAnalyticsModel[]) => {
          return data;
        }),
        catchError(error => {
          this.logger.info('DAG Analytics Service error ==> ', error);
          return throwError('Something went wrong while fetching DAG analytics data!');
        })
      );
  }

  private handleError(error: any) {
    console.error('An error occurred:', error);
    return throwError('Something went wrong; please try again later.');
  }
}
